<template>
  <form id="create_device_form">
    <div class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">افزودن دستگاه</h3>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>نام</label>
              <input
                type="text"
                name="name"
                v-model="form.name"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="required">کد</label>
              <input
                type="text"
                name="code"
                v-model="form.code"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>نوع</label>
          <div class="radio-inline">
            <label
              v-for="type in deviceTypes"
              :key="`type-${type}`"
              class="radio"
            >
              <input
                type="radio"
                name="plan"
                :value="type"
                v-model="form.type"
              />
              <span></span>
              {{ typesTrans[type] }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { mapGetters } from "vuex";
import { STORE_ADMIN_DEVICE } from "@/core/services/store/admin/devices.module";

export default {
  name: "devices-create",
  data() {
    return {
      form: {
        name: "",
        code: "",
        type: "1"
      }
    };
  },
  components: {},
  mounted() {
    this.setBreadcrumbs();
    this.setActions();

    this.eventHub.$on("save-device-event", this.save);

    this.fv = formValidation(document.getElementById("create_device_form"), {
      fields: {
        code: {
          validators: {
            notEmpty: {
              message: "کد الزامی است"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },
  beforeDestroy() {
    this.eventHub.$off("save-device-event");
    document.getElementById("save-device-btn").disabled = false;
  },
  computed: {
    ...mapGetters(["deviceTypes", "typesTrans"])
  },
  methods: {
    setBreadcrumbs() {
      let items = [];

      if (this.$route.query.device) {
        items.push({
          title: "مدیریت",
          route: { name: "admin-dashboard" }
        });

        items.push({
          title: "دستگاه ها",
          route: { name: "admin-devices-index" }
        });
      }

      items.push({ title: "افزودن دستگاه" });

      this.$store.dispatch(SET_BREADCRUMB, items);
    },
    setActions() {
      this.$store.dispatch(SET_ACTIONS, {
        buttons: [
          {
            name: "ذخیره",
            event: "save-device-event",
            class: "btn-primary",
            id: "save-device-btn"
          }
        ],
        links: [
          {
            name: "بازگشت",
            to: {
              name: "admin-devices-index",
              params: { id: this.$route.query.device }
            }
          }
        ]
      });
    },
    save() {
      this.fv.validate().then(status => {
        if (status === "Valid") {
          let submitBtn = document.getElementById("save-device-btn");
          this.disableBtn(submitBtn);

          this.$store
            .dispatch(STORE_ADMIN_DEVICE, {
              project_id: this.$route.params.id,
              name: this.form.name
                ? this.form.name
                : this.$store.state.devices.typesEnum[this.form.type],
              code: this.form.code,
              type: this.form.type
            })
            .then(data => {
              this.$router.push({
                name: "admin-devices-show",
                params: { id: data.id },
                query: this.$route.query
              });
            })
            .catch(() => {
              this.enableBtn(submitBtn);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا فرم را به شکل صحیح کامل کنید");
        }
      });
    }
  }
};
</script>
